import { columnDefs } from "../../helpers/helper";
import { Queue } from "../../helpers/Queue";
import ACTION_TYPES from "../types";

// reducer.js
const INITIAL_STATE = {
   currentSheetRows: [],
   currentRowsObject: null,
   currentSheetColumnDefs:[],
   currentSheetColumnState:[],
   selectedColumn:"",
   isInitialized: false,
   originalColumnIndex: {},
   colIdObj:{},
   sheetLoader: true,
   globalStyle:{
    format: {
        bold:false,
        underline:false,
        italic:false,
        strikethrough:false
      },
      cellStyle: {
        backgroundColor:"transparent",
        fontFamily:"Arial",
        fontSize:"12px",
        color:"black"
      }
   },
   namedFilters:[],
   cloneRowsData: null
}

const currentSheetDataReducer =  (state = INITIAL_STATE, action) => {
	switch(action.type) {
		case ACTION_TYPES.SET_SHEET_ROW_DATA:
            return {
                ...state,
                currentSheetRows: action.currentSheetRows || state.currentSheetRows,
                currentRowsObject: action.currentRowsObject || state.currentRowsObject,
                sheetLoader:action.sheetLoader || false,
            }
        case ACTION_TYPES.SET_CURRENT_ROW_OBJECT:
            return {
              ...state,
              currentRowsObject: action.currentRowsObject,
            }
        case ACTION_TYPES.SET_CURRENT_SHEET_INFO:
            return {                
                ...state,
                currentRowsObject: action.currentRowsObject || state.currentRowsObject,
                currentSheetRows: action.currentSheetRows || state.currentSheetRows,
                currentSheetColumnDefs: action.currentSheetColumnDefs || state.currentSheetColumnDefs,
                currentSheetColumnState: action.currentSheetColumnState || state.currentSheetColumnState,
                selectedColumn:action.selectedColumn || state.selectedColumn,
                colIdObj: action.colIdObj || state.colIdObj,
                namedFilters : action.namedFilters || state.namedFilters
            }
        case ACTION_TYPES.SET_GLOBAL_STYLE:
            return {
                ...state,
                globalStyle:action.payload
            }
        case ACTION_TYPES.SET_CLONE_DATA_OF_ROWS:
            return {
                ...state,
                cloneRowsData: action.cloneRowsData,
            };
		default:
			return state;
	}
};

export default currentSheetDataReducer;